import { Button, InputAdornment } from '@bw/foundry';

import React from 'react';

interface EditButtonProps {
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  onMouseDown?: () => void;
}
const EditButton: React.FC<EditButtonProps> = ({ onClick, onMouseDown }) => {
  return (
    <InputAdornment position="end">
      <Button
        variant="text"
        name="reset"
        type="button"
        onClick={onClick}
        onMouseDown={onMouseDown}
      >
        Edit
      </Button>
    </InputAdornment>
  );
};
export default EditButton;
